

export default [
  {
    title: 'รายงาน',
    icon: 'HomeIcon',
    // tag: '2',
    tagVariant: 'light-warning',
    route: 'report-one',
  },
]
